module.exports = __webpack_public_path__ + "static/media/homer.f53c8d32.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/css_art/homer.gif
// module id = 109
// module chunks = 0